import { utils } from "../utils/utils"
import { HttpClient } from "./serviceBase"

const MapCreate = (movement) => ({
    ...movement,
    warehouseId: movement.warehouse?.id || movement.warehouseId,
    referralCodes: movement.referrals?.map(r => r.code) || [],
})

const MapUpdate = (movement) => ({
    movementId: movement.id,
    reason: movement.reason,
    details: movement.details,
    referralCodes: movement.referrals?.map(r => r.code) || [],
    state: movement.state,
    active: movement.active,
    branchCode: movement.branchCode
})

const mapFilters = (filters) => ({
    ...filters,
    state: filters.state !== 'all' ? filters.state : '',
    type: filters.type !== 'all' ? filters.type : '',
    subType: filters.subType !== 'all' ? filters.subType : ''
});

class MovementService {
    Search = async (filters) => {
        const queryString = utils.GetQueryStringsFromObject(mapFilters(filters));
        return await HttpClient.Get(`/api/movements?${queryString}`);
    }

    Get = async (movementId) =>
        await HttpClient.Get(`/api/movements/${movementId}`);

    GetIncomeOutcome = async (productId) =>
        await HttpClient.Get(`/api/movements/incomeOutcome/${productId}`);

    Create = async (movement) =>
        await HttpClient.Post(`/api/movements`, MapCreate(movement));

    Update = async (movement) =>
        await HttpClient.Put(`/api/movements/${movement.id}`, MapUpdate(movement));

    Delete = async (movementId) =>
        await HttpClient.Delete(`/api/movements/${movementId}`);

    Adjust = async (movement) =>
        await HttpClient.Post(`/api/movements/adjust`, MapCreate(movement));

    SearchWarehouse = async (filters) => {
        const queryString = utils.GetQueryStringsFromObject(filters);
        return await HttpClient.Get(`/api/warehouse/SearchWarehouse?${queryString}`);
    }

    CreateAdjustments = async (movement) =>
        await HttpClient.Post(`/api/movements/adjustments`, MapCreate(movement));

    CreateReceptions = async (movement) =>
        await HttpClient.Post(`/api/movements/receptions`, MapCreate(movement));

    CreateTransfer = async (movement) =>
        await HttpClient.Post(`/api/movements/transfer`, MapCreate(movement));

    ExportReception = async (details) =>
        await HttpClient.PostFile(`/api/movements/export/receptions`, details);

    SearchHistory = async (refId, filters, config) => {
        const queryString = utils.GetQueryStringsFromObject(filters);
        return await HttpClient.Get(`/api/products/${refId}/history?${queryString}`, config);
    }
}

export default new MovementService();